import Vue from 'vue'
import Vuex from 'vuex'
//import  {app}  from './main'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		commonalityData: {
			MaUserId: '',
			IdcodeUserId: '',
			name: '',
			official: '',
			platformRole: ''
		},
		userSet: false,
		active: 1,
		resistshow: false,
		resistCode: '',
		//				retrospect: [{
		//					url: '/',
		//					name: '首页'
		//				}, ],
	},
	mutations: {
		resist(state, type) {
			state.resistCode = type || '';
						state.resistshow = true;

		},
		resistopen(state) {
			state.resistshow = true;
		},
		resistDestroy(state) {
			state.resistshow = false;

		},
		increment(state, index) {
			state.active = index;
		},

		userGuard(state, dispark) {
			state.userSet = dispark;

		},

		//				routerSign(state, route) {
		////								console.log(vue)
		//					if(route.meta) {
		//						//				vue.$set(state.retrospect, route.meta.tier - 1, {
		//						//					url: to.path,
		//						//					name: route.meta.presentName
		//						//				})
		////						console.log(state.retrospect.length - route.meta.tier)
		//						
		//						
		//						let index =state.retrospect.length - route.meta.tier
		//						console.log(index <0 ?1:index+1)
		//						state.retrospect.splice(route.meta.tier-1,index <0 ?1:index+1,{
		//											url: route.path,
		//											name: route.meta.presentName
		//										})
		//					}
		//					}
	},
	actions: {
		DataUpdate(context, reception = {}) {
			//			reception.organunit_id
			return new Promise((resolve, reject) => {
				context.state.commonalityData.IdcodeUserId = reception.organunit_id;
				context.state.commonalityData.name = reception.organunitname;
				context.state.commonalityData.official = reception.domain;
				context.state.commonalityData.platformRole = reception.platformRole === '' ? 4 : reception.platformRole;
				resolve(reception)
			})
		},
	}
})